import ShelterModal from './ShelterModal';

export default ShelterModal;
